import { Button, Result } from "antd";
import { HistoryTable } from "./HistoryTable/HistoryTable";
import { PatientSummaryFromId } from "molecules/PatientSummary";
import { VyneModal } from "@vyne-shared/components/vyneModal/VyneModal";
import { antdModalV5, create, useModal } from "@ebay/nice-modal-react";
import { usePatientHistory } from "api/clients/usePatientHistory";

interface HistoryModalProps {
    /** The ID of the Patient/Responsible Party whose history we are displaying. */
    readonly patientId: number;
}

export const HistoryModal = create<HistoryModalProps>(({ patientId }) => {
    const modal = useModal();

    const { isPending, isError, data } = usePatientHistory(patientId);

    return (
        <VyneModal
            {...antdModalV5(modal)}
            className="transaction-history-modal"
            width={758}
            title="Event History"
            footer={<Button onClick={() => void modal.hide()}>Close</Button>}
        >
            <PatientSummaryFromId id={patientId} />
            {isError ? (
                <Result
                    status="500"
                    title="Unable to get patient history"
                    subTitle="There was a problem retrieving patient history. Contact support if this error persists."
                />
            ) : (
                <HistoryTable
                    name="Patient History Table"
                    patientId={patientId}
                    events={data}
                    hideModal={() => void modal.hide()}
                    loading={isPending}
                />
            )}
        </VyneModal>
    );
});
